import { module } from './app';
import * as stateConstants from "./constants/state-constants";

module.config([
  '$stateProvider', '$urlRouterProvider', '$ionicConfigProvider',
  function ($stateProvider, $urlRouterProvider, $ionicConfigProvider) {
    $stateProvider
      .state('login', {
        url: "/login",
        templateUrl: "views/login.html",
        controller: "LoginCtrl"
      })
      .state('root', {
        url: "/root",
        templateUrl: "views/root.html",
        controller: "MainCtrl",
        abstract: true,
        resolve: {
          techpadConfigPromise: [
            'techpadConfig',
            async function (techpadConfig) {
              return await techpadConfig.init();
            }
          ]
        }
      })
      .state(stateConstants.MY_PATIENTS_STATE_NAME, {
        url: stateConstants.MY_PATIENTS_URL,
        state: {
          pageTitle: stateConstants.MY_PATIENTS_PAGE_TITLE,
          enableSearchButton: stateConstants.MY_PATIENTS_ENABLE_SEARCH_BUTTON,
          enableFilterButton: stateConstants.MY_PATIENTS_ENABLE_FILTER_BUTTON,
          enableOutsideStudiesOption: stateConstants.MY_PATIENTS_ENABLE_OUTSIDE_STUDIES_OPTION,
          isMyPatients: stateConstants.MY_PATIENTS_IS_MY_PATIENTS,
          shouldShowTags: stateConstants.MY_PATIENTS_SHOULD_SHOW_TAGS,
          enableLinkExamsOption :stateConstants.MY_PATIENTS_ENABLE_LINK_EXAMS_OPTION
        },
        views: {
          'menuContent': {
            templateUrl: stateConstants.MY_PATIENTS_TEMPLATE_URL,
            controller: stateConstants.MY_PATIENTS_CONTROLLER
          }
        }
      })
      .state('root.worklist', {
        url: "/worklist",
        views: {
          'menuContent': {
            templateUrl: "views/templates/worklistTabTemplate.html",
            controller: "WorklistCtrl"
          }
        },
        cache: false
      })
      .state('root.speedtest', {
        url: "/speedtest",
        views: {
          'menuContent': {
            templateUrl: "views/speedtest.html",
            controller: "speedTestCtrl"
          }
        }
      })
      .state('root.patient', {
        url: "/patient/:id",
        views: {
          'menuContent': {
            templateUrl: "views/patient.html",
            controller: "PatientCtrl"
          }
        },
        data:{
          customRestrictionCheck: true 
        }
      })
      .state('root.patient_diagram', {
        url: "/editDiagram?ssn?sdate",
        views: {
          'menuContent': {
            templateUrl: "views/editDiagram.html",
            controller: "DiagramEditingController"
          }
        },
        data: {
          allowAnonymous: true
        }
      })
      .state('root.scheduled', {
        url: "/scheduled",
        views: {
          'menuContent': {
            templateUrl: "views/home.html",
            controller: "ScheduledCtrl"
          }
        }
      })
      .state('root.demo', {
        url: "/demo",
        views: {
          'menuContent': {
            templateUrl: "views/demo.html",
            controller: "DemoCtrl"
          }
        }
      })
      .state('root.options', {
        url: "/options",
        views: {
          'menuContent': {
            templateUrl: "views/options.html",
            controller: "OptionsCtrl"
          }
        }
      })
      .state('root.diagram', {
        url: "/diagram",
        views: {
          'menuContent': {
            templateUrl: "views/diagram.html",
            controller: "DiagramCtrl"
          }
        }
      })
      .state('root.patients', {
        url: "/patients",
        views: {
          'menuContent': {
            templateUrl: "views/patientsList.html",
            controller: "PatientsListCtrl"
          }
        }
      })
      .state('root.patient_details', {
        url: "/patient/details/:accessToken",
        views: {
          'menuContent': {
            templateUrl: "views/patientDetailsInitial.html",
            controller: "PatientDetailsCtrl"
          }
        }
      })
      .state('root.study_details', {
        url: "/study/details/:accessToken/:sdate",
        views: {
          'menuContent': {
            templateUrl: "views/studyDetails.html",
            controller: "StudyDetailsCtrl"
          }
        }
      })
      .state('root.otherStudyDetails', {
        url: "/worklist/otherStudy/:worklistId",
        views: {
          'menuContent': {
            templateUrl: "views/otherStudyDetails.html",
            controller: "OtherStudyDetailsCtrl"
          }
        },
        data:{
          customRestrictionCheck: true 
        }
      })
      .state('root.chat-master', {
        url: "/conversations",
        views: {
          'menuContent': {
            templateUrl: "views/chatModule/conversation-list.html",
            controller: "ChatConversationController"
          }
        }
      })
      .state('root.chat-detail', {
        url: "/conversations/:conversationId",
        views: {
          'menuContent': {
            templateUrl: "views/chatModule/conversation-list.html",
            controller: "ChatConversationController"
          }
        }
      });

    $ionicConfigProvider.views.maxCache(0);
    $urlRouterProvider.otherwise("/login");
  }]);



// WEBPACK FOOTER //
// ./src/scripts/stateConfig.js